import React, { useState, useCallback } from "react";
import { Alert, Button, } from "@mui/material";
import { api } from "../../../services/api";
import moment from "moment-timezone";
import "./evento.css";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import ImageSection from "../../../components/evento/crearEvento/ImageSection";
import NameSection from "../../../components/evento/crearEvento/NameSection";
import DateSection from "../../../components/evento/crearEvento/DateSection";
import DetailsSection from "../../../components/evento/crearEvento/DetailsSection";
import SponsorsSection from "../../../components/evento/crearEvento/SponsorsSection";

const CrearEvento = ({ setEventId, setEventoCreado }) => {
	const [evento, setEvento] = useState("");
	const [descripcion, setDescripcion] = useState("");
	const [error, setError] = useState("");
	/* const localTime = moment.tz.guess(); */
	const [submitted, setSubmitted] = useState(false);
	const [t] = useTranslation("global");
	const [loading, setLoading] = useState(false);

	const [mediaData, setMediaData] = useState({
		files: [],
		mediaUrls: [],
		mediaTypes: [],
		mediaFormats: [],
		mediaId: []
	});
	const [fechas, setFechas] = useState([{ fecha: "", hora_inicio: "", hora_fin: "" }]);
	const [variosDias, setVariosDias] = useState(false);

	const [direccion, setDireccion] = useState("");
	const [ciudadSeleccionada, setCiudadSeleccionada] = useState("");
	const [provSeleccionada, setProvSeleccionada] = useState("");
	const [ubicacionCompleta, setUbicacionCompleta] = useState({});

	const [sponsorsData, setSponsorsData] = useState([]);

	const handleFechasChange = useCallback((datosFechas) => {
		setFechas(datosFechas.fechas);
		setVariosDias(datosFechas.variosDias);
	}, []);

	const handleUbicacionChange = useCallback((datosUbicacion) => {
		setDireccion(datosUbicacion.direccion);
		setCiudadSeleccionada(datosUbicacion.ciudad);
		setProvSeleccionada(datosUbicacion.provincia);
		setUbicacionCompleta(datosUbicacion);
	}, []);

	const handleMediaChange = useCallback((newMediaData) => {
		setMediaData(prevData => {
			// solo actualiza si hay cambios en las imagenes
			if (JSON.stringify(prevData) !== JSON.stringify(newMediaData)) {
				return newMediaData;
			}
			return prevData;
		});
	}, []);

	const handleMediaError = useCallback((newError) => {
		setError(prevError => {
			// solo actualiza si hay cambios para evitar renderizaciones innecesarias
			if (JSON.stringify(prevError.files) !== JSON.stringify(newError.files)) {
				return {
					...prevError,
					files: newError.files
				};
			}
			return prevError;
		});
	}, []);

	const [eventos_tipos_id, setEventosTiposId] = useState("");
	const [publicoprivado, setPublicoPrivado] = useState("");
	const [conSalida, setConSalida] = useState(false);

	const handleDetailsChange = useCallback((datosDetails) => {
		setEventosTiposId(datosDetails.eventos_tipos_id);
		setPublicoPrivado(datosDetails.publicoprivado);
		setConSalida(datosDetails.conSalida);
	}, []);

	const handleSponsorsChange = useCallback((newSponsorsData) => {
		setSponsorsData(prevData => {
			if (JSON.stringify(prevData) !== JSON.stringify(newSponsorsData)) {
				return newSponsorsData;
			}
			return prevData;
		});
	}, []);

	const handleSponsorsError = useCallback((newError) => {
		setError(prevError => ({
			...prevError,
			sponsors: newError.sponsors
		}));
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		const regexE = /^(?!([a-zA-Z0-9])\1+$)[a-zA-Z0-9\sñÑ\u00C0-\u017F]*$/;
		// const hoy = new Date();
		// const fechasel = new Date(fecha);
		// const fechamax = new Date().setFullYear(hoy.getFullYear() + 1);

		const newErrors = [];

		if (mediaData.files.length === 0) newErrors.files = "Por favor, sube un archivo.";

		if (evento.trim() === "")
			newErrors.evento = "El nombre del evento no puede estar vacío.";
		/* if (!regexE.test(evento))
			newErrors.evento =
				"Evita el uso de caracteres especiales en el nombre del evento"; */
		if (evento.length > 50)
			newErrors.evento = "El nombre del evento no puede exceder 50 caracteres.";
		if (evento.length < 5)
			newErrors.evento =
				"El nombre del evento debe tener al menos 5 caracteres.";

		if (descripcion.trim() === "")
			newErrors.descripcion = "La descripción es obligatoria.";
		/* if (descripcion.length > 480)
			newErrors.descripcion = "La descripción no puede superar 250 caracteres."; */
		if (descripcion.length < 5)
			newErrors.descripcion = "La descripción necesita al menos 5 caracteres.";

		// if (fechasel < hoy.setHours(0, 0, 0, 0)) {
		// 	newErrors.fecha = "La fecha no puede ser anterior al día actual.";
		// }
		// if (fechasel > fechamax) newErrors.fecha = t("errors.errorDate");
		// if (fecha === "" || hora === "")
		// 	newErrors.hora = "La fecha y hora son necesarias.";
		if (ciudadSeleccionada === "" || direccion === "") newErrors.direccion = "La ciudad y la direccion no pueden estar vacías."

		if (eventos_tipos_id === "")
			newErrors.eventos_tipos_id = "Selecciona un tipo de evento.";
		if (publicoprivado === "")
			newErrors.publicoprivado =
				"Es necesario seleccionar si el evento es público o privado.";

		// detiene el envio si hay errores
		if (Object.keys(newErrors).length > 0) {
			setError(newErrors);
			return;
		}

		setLoading(true);

		const pp = publicoprivado === "true" ? true : false;
		const data = {
			evento: {
				evento: evento,
				descripcion: descripcion,
				eventos_tipos_id: eventos_tipos_id,
				privado: pp,
				consalidas: conSalida,
				direccion: direccion,
				ciudad: ciudadSeleccionada,
			},
			attachs: mediaData.mediaUrls.map((url, index) => ({
				url: url,
				type: mediaData.mediaTypes[index],
				format: mediaData.mediaFormats[index],
				public_id: mediaData.mediaId[index],
				avatar: mediaData.mediaUrls.length === 1 || index === 0,
				banner: mediaData.mediaUrls.length === 1 || index === 1,
				...(index > 1 && { avatar: false, banner: false })
			})),
			fechas: fechas.map((item) => ({
				fecha: moment(item.fecha)
					.tz("America/Buenos_Aires")
					.format("YYYY-MM-DDTHH:mm:ss-03:00"),
				hora_inicio: moment(`${item.fecha}T${item.hora_inicio}`)
					.tz("America/Buenos_Aires")
					.format("YYYY-MM-DDTHH:mm:ss-03:00"),
				hora_fin: moment(`${item.fecha}T${item.hora_fin}`)
					.tz("America/Buenos_Aires")
					.format("YYYY-MM-DDTHH:mm:ss-03:00"),
				acceso_inicio: moment(`${item.fecha}T${item.acceso_inicio || item.hora_inicio}`)
					.tz("America/Buenos_Aires")
					.format("YYYY-MM-DDTHH:mm:ss-03:00"),
			})),
			sponsors: sponsorsData.map((sponsor, index) => ({
				nombre: sponsor.nombre,
				url: sponsor.url,
				type: sponsor.type,
				format: sponsor.format,
				public_id: sponsor.public_id,
				orden: index + 1
			})).filter(sponsor => sponsor.nombre && sponsor.url)
		};

		const response = api.eventos.createEvento(data);
		return response
			.then((response) => {
				if (response.status === "error") {
					setError("Error: " + response.message);
					setEventoCreado(false);
				}
				if (response.status === "success") {
					const newEventId = response.data.evento.id;
					setEventId(newEventId);
					setEvento("");
					setDescripcion("");
					setDireccion("");
					setPublicoPrivado("");
					setError("");
					setSubmitted(true);
					setEventoCreado(true);
				}
			})
			.catch((error) => {
				setError("Error: No se pudo conectar con el servidor");
				console.error("Error al crear evento:", error);
			})
			.finally(() => {
				setLoading(false);
			});
	};



	return (
		<div className="contenedor-evento">
			<form id="form-evento" onSubmit={handleSubmit}>

				{/* SECCION IMAGENES */}
				<ImageSection
					onMediaChange={handleMediaChange}
					onErrorChange={handleMediaError}
					error={error} />

				{/* SECCION TITULO */}
				<NameSection evento={evento}
					setEvento={setEvento}
					descripcion={descripcion}
					setDescripcion={setDescripcion}
					error={error} />

				{/* SECCION FECHA Y LUGAR */}
				<DateSection
					error={error}
					onFechasChange={handleFechasChange}
					onUbicacionChange={handleUbicacionChange}
				/>

				{/* SECCION MAS DETALLES */}
				<DetailsSection
					error={error}
					onDetailsChange={handleDetailsChange}
				/>

				{/* SECCION SPONSORS */}
				<SponsorsSection
					onSponsorsChange={handleSponsorsChange}
					onErrorChange={handleSponsorsError}
					error={error}
					initialSponsors={[]}
				/>

				{error && (
					<Alert severity="error">
						Por favor, chequea la información ingresada.
					</Alert>
				)}
				{submitted && <Alert color="success">{t("event.successCreate")}</Alert>}
				{!submitted && (
					<Button
						type="submit"
						form="form-evento"
						className="mt-3 boton-submit"
						disabled={loading}
					>
						{loading ? (
							<>
								<CircularProgress size={20} color="inherit" className="me-2" />
								Creando evento...
							</>
						) : (
							`${t("button.create")} evento`
						)}
					</Button>
				)}
			</form>
		</div>
	);
};

export default CrearEvento;
